import React from "react";
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

function AttachmentModal({ attachmentUrl, contentClassName, showModalHeader, toggleAttachmentModal }) {
    const showHeader = showModalHeader ? showModalHeader : true;
    const modalBody = contentClassName === 'attachment-modal--video'
        ? <div className="embed-responsive embed-responsive-16by9"><iframe id="dcjMsgAttachment" className="embed-responsive-item" src={attachmentUrl} /></div>
        : <iframe id="dcjMsgAttachment" src={attachmentUrl} />;

    return (
        <Modal isOpen={true} toggle={toggleAttachmentModal}
            centered
            className="attachment-modal"
            contentClassName={contentClassName ? contentClassName : ""}
        >
            {showHeader && <ModalHeader toggle={toggleAttachmentModal} />}
            <ModalBody>
                {modalBody}
            </ModalBody>
        </Modal>
    );

}

export default AttachmentModal;